import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(AuthContext);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Prevent background scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const handleAction = () => {
    setMenuOpen(false);
    navigate(userData ? "/home" : "/auth");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUserData(null);
    setMenuOpen(false);
    navigate("/");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="qm-nav">
      {/* Brand */}
      <Link to="/" className="qm-nav-brand">QuickMeet</Link>

      {/* Center links — hidden on mobile, shown via drawer */}
      <div className={`qm-nav-links${menuOpen ? " qm-nav-links--open" : ""}`}>
        <Link
          to="/about"
          className={`qm-nav-link${isActive("/about") ? " qm-nav-link--active" : ""}`}
          onClick={() => setMenuOpen(false)}
        >
          About
        </Link>
        <Link
          to="/contact"
          className={`qm-nav-link${isActive("/contact") ? " qm-nav-link--active" : ""}`}
          onClick={() => setMenuOpen(false)}
        >
          Contact
        </Link>
      </div>

      {/* Action buttons — hidden on mobile, shown via drawer */}
      <div className={`qm-nav-actions${menuOpen ? " qm-nav-actions--open" : ""}`}>
        {userData ? (
          <>
            {isActive("/home") ? (
              <button className="qm-nav-btn qm-nav-btn--ghost" onClick={() => { navigate("/history"); setMenuOpen(false); }}>
                🕒 History
              </button>
            ) : (
              <button className="qm-nav-btn qm-nav-btn--ghost" onClick={() => { navigate("/home"); setMenuOpen(false); }}>
                Dashboard
              </button>
            )}
            <button className="qm-nav-btn qm-nav-btn--outline" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <button className="qm-nav-btn qm-nav-btn--secondary" onClick={handleAction}>Log In</button>
            <button className="qm-nav-btn qm-nav-btn--primary" onClick={handleAction}>Sign Up</button>
          </>
        )}
      </div>

      {/* Hamburger toggle — only visible on mobile */}
      <button
        className={`qm-hamburger${menuOpen ? " qm-hamburger--open" : ""}`}
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Overlay */}
      {menuOpen && <div className="qm-nav-overlay" onClick={() => setMenuOpen(false)} />}

      {/* Mobile drawer */}
      <div className={`qm-mobile-menu${menuOpen ? " qm-mobile-menu--open" : ""}`}>
        {/* Close button */}
        <button
          className="qm-mobile-close"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        >
          ✕
        </button>
        <Link
          to="/about"
          className={`qm-mobile-link${isActive("/about") ? " qm-mobile-link--active" : ""}`}
          onClick={() => setMenuOpen(false)}
        >
          About
        </Link>
        <Link
          to="/contact"
          className={`qm-mobile-link${isActive("/contact") ? " qm-mobile-link--active" : ""}`}
          onClick={() => setMenuOpen(false)}
        >
          Contact
        </Link>

        <div className="qm-mobile-divider" />

        {userData ? (
          <>
            {isActive("/home") ? (
              <button className="qm-nav-btn qm-nav-btn--ghost qm-mobile-btn" onClick={() => { navigate("/history"); setMenuOpen(false); }}>
                🕒 History
              </button>
            ) : (
              <button className="qm-nav-btn qm-nav-btn--ghost qm-mobile-btn" onClick={() => { navigate("/home"); setMenuOpen(false); }}>
                Dashboard
              </button>
            )}
            <button className="qm-nav-btn qm-nav-btn--outline qm-mobile-btn" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <button className="qm-nav-btn qm-nav-btn--secondary qm-mobile-btn" onClick={handleAction}>Log In</button>
            <button className="qm-nav-btn qm-nav-btn--primary qm-mobile-btn" onClick={handleAction}>Sign Up</button>
          </>
        )}
      </div>
    </nav>
  );
}